// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.difficult-page {
  max-width: 600px;
  margin: 0 auto;
}

.difficult-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.difficult-header h2 {
  margin: 0;
}

.difficult-card {
  background: white;
  border-radius: 24px;
  padding: 40px 24px;
  text-align: center;
  box-shadow: var(--shadow);
  margin-bottom: 24px;
}

.polish-word-large {
  font-size: 48px;
  font-weight: 800;
  color: var(--secondary);
  margin-bottom: 32px;
}

.english-answer {
  font-size: 42px;
  font-weight: 700;
  color: var(--success);
  margin-bottom: 24px;
}

.english-answer .speak-btn {
  font-size: 32px;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 12px;
  vertical-align: middle;
}

.self-check {
  font-size: 18px;
  color: #666;
  margin-bottom: 16px;
}

.answer-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.answer-buttons .btn {
  min-width: 120px;
  font-size: 20px;
  padding: 16px 24px;
}

.btn-success {
  background: var(--success);
  color: white;
}

.btn-danger {
  background: var(--danger);
  color: white;
}

.memorization-info {
  text-align: center;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 12px;
}

.mem-label {
  color: #666;
  margin-right: 8px;
}

.mem-level {
  font-weight: 700;
  color: var(--primary);
  font-size: 20px;
}

.no-difficult, .difficult-complete {
  text-align: center;
  padding: 60px 20px;
}

.no-difficult-icon, .difficult-complete .complete-icon {
  font-size: 80px;
  margin-bottom: 16px;
}

.no-difficult h2, .difficult-complete h1 {
  margin-bottom: 12px;
}

.no-difficult p, .difficult-complete p {
  color: #666;
  margin-bottom: 24px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/DifficultWords.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".difficult-page {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.difficult-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.difficult-header h2 {\n  margin: 0;\n}\n\n.difficult-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px 24px;\n  text-align: center;\n  box-shadow: var(--shadow);\n  margin-bottom: 24px;\n}\n\n.polish-word-large {\n  font-size: 48px;\n  font-weight: 800;\n  color: var(--secondary);\n  margin-bottom: 32px;\n}\n\n.english-answer {\n  font-size: 42px;\n  font-weight: 700;\n  color: var(--success);\n  margin-bottom: 24px;\n}\n\n.english-answer .speak-btn {\n  font-size: 32px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-left: 12px;\n  vertical-align: middle;\n}\n\n.self-check {\n  font-size: 18px;\n  color: #666;\n  margin-bottom: 16px;\n}\n\n.answer-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n}\n\n.answer-buttons .btn {\n  min-width: 120px;\n  font-size: 20px;\n  padding: 16px 24px;\n}\n\n.btn-success {\n  background: var(--success);\n  color: white;\n}\n\n.btn-danger {\n  background: var(--danger);\n  color: white;\n}\n\n.memorization-info {\n  text-align: center;\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 12px;\n}\n\n.mem-label {\n  color: #666;\n  margin-right: 8px;\n}\n\n.mem-level {\n  font-weight: 700;\n  color: var(--primary);\n  font-size: 20px;\n}\n\n.no-difficult, .difficult-complete {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.no-difficult-icon, .difficult-complete .complete-icon {\n  font-size: 80px;\n  margin-bottom: 16px;\n}\n\n.no-difficult h2, .difficult-complete h1 {\n  margin-bottom: 12px;\n}\n\n.no-difficult p, .difficult-complete p {\n  color: #666;\n  margin-bottom: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
